package com.gsb.vyapar.bhagya.datasource.network

import com.gsb.vyapar.bhagya.util.value
import io.ktor.http.HttpHeaders

val headerJsonContentType = HttpHeaders.ContentType to "application/json"
val headerGithubAuthorization = HttpHeaders.Authorization to "token ${GITHUB_UPLOAD_KEY.value()}"
val headerGithubAuthorizationN = HttpHeaders.Authorization to "token ${GITHUB_UPLOAD_KEY_N.value()}"
